// 引入Vue
import Vue from 'vue'

// 引入Vuex
import Vuex from 'vuex'

// 引入hamburger
import hamburger from './modules/hamburger'

// 引入tagView
import tagView from './modules/tagView'

// 通过中间件使用Vuex
Vue.use(Vuex);

// 暴露store
export default new Vuex.Store({
    // store模块
    modules: {
        hamburger,
        tagView
    }
});
;



// WEBPACK FOOTER //
// ./src/store/index.js